module.exports = __webpack_public_path__ + "img/about.25442976.png";